module.exports = "\n  <router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /Users/pkovacs/Documents/Development/ngsAlpha/ngs_alpha_ui/src/app/layouts/auth/auth-layout.component.html
// module id = ../../../../../src/app/layouts/auth/auth-layout.component.html
// module chunks = main